import { useState } from 'react';

export function useColumnSearches(fields: string[]) {
  const initialState = fields.reduce((acc, field) => {
    acc[field] = '';
    return acc;
  }, {} as Record<string, string>);

  const [columnSearches, setColumnSearches] = useState<Record<string, string>>(initialState);

  const setSearch = (field: string, value: string) => {
    setColumnSearches((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const clearSearch = (field: string) => {
    setColumnSearches((prev) => ({
      ...prev,
      [field]: '',
    }));
  };

  const clearAllSearches = () => {
    setColumnSearches(initialState);
  };

  return {
    columnSearches,
    setSearch,
    clearSearch,
    clearAllSearches,
  };
}
